import type { TranslationInterface } from '.';

export const FrenchLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Écrivez un message...',
  your_issue_has_been_resolved: 'Votre problème a été résolu !',
  new_conversation: 'Nouvelle conversation',
  welcome_screen_title: 'Bienvenue dans notre chat de support',
  welcome_screen_description:
    'Nous sommes là pour vous aider ! Commencez une conversation et nous vous répondrons dès que possible.',
  your_name_placeholder: 'Votre nom',
  your_email_placeholder: 'Votre adresse e-mail',
  start_chat_button: 'Parler au support',
  start_chat_button_loading: 'Connexion...',
  i_need_more_help: "Je besoin d'aide plus",
  this_was_helpful: "C'était utile",
  optional: 'Optionnel',
  no_conversations_yet: 'Aucune conversation pour le moment',
  back_to_conversations: 'Retour aux conversations',
  closed_conversations: 'Conversations fermées',
  csat_title: 'Comment s’est passée votre conversation ?',
  csat_submitted_title: 'Vous avez évalué la conversation comme',
  csat_feedback_placeholder: 'Dites-nous en plus... (facultatif)',
  follow_up_placeholder: 'Poser une autre question…',
  companion_layout_label: 'Disposition',
  companion_layout_floating: 'Flottant',
  companion_layout_sidebar: 'Barre latérale',
  companion_layout_fullscreen: 'Plein écran',
  companion_close: 'Fermer',
  companion_history: 'Historique des conversations',
  companion_expand_chat: 'Agrandir le chat',
  companion_sidebar_dock_label: 'Ancrage',
  companion_sidebar_side_label: 'Côté',
  companion_sidebar_left: 'Gauche',
  companion_sidebar_right: 'Droite',
  companion_resize_chat: 'Redimensionner le chat',
  scroll_to_bottom: 'Faire défiler vers le bas',
  thinking: 'Réflexion…',
  running: 'En cours…',
  steps: 'étapes',
  step_arguments: 'Arguments',
  step_result: 'Résultat',
  attach_files:
    'Joindre des images, des vidéos, des PDF ou des feuilles de calcul (taille maximale 25 Mo)',
  mark_page_active:
    'Cliquez sur un élément de la page pour le marquer — Échap pour annuler',
  mark_page:
    'Marquez un élément de la page pour poser une question à son sujet',
  stop_response: 'Arrêter la réponse',
  copy_reply: 'Copier la réponse',
  mentions_empty: 'Aucun résultat',
  copied: 'Copié',
  send_message: 'Envoyer le message',
  upload_failed: 'Échec du téléversement : {error}',
  remove_attachment: 'Supprimer la pièce jointe',
  json_no_items: 'Aucun élément',
  json_no_data: 'Aucune donnée',
  json_no_chart_data: 'Aucune donnée à afficher dans le graphique',
  json_unsupported: 'Non pris en charge : {type}',
  json_see_less: 'Voir moins',
  json_phone_agent: 'Agent téléphonique',
  json_phone_agent_test: 'Tester via le web',
  page_context_remove: 'Retirer le contexte de la page',
  json_see_more: 'Voir {count} de plus',
  queued_label: '{count} En attente',
  remove_queued_message: 'Retirer le message de la file d’attente',
  send_queued_now: 'Envoyer les messages en attente maintenant',
  turn_failed_message:
    'Un problème est survenu et la réponse n’est pas arrivée.',
  turn_failed_retry: 'Réessayer',
  page_mark_hint: 'Cliquez sur un élément pour le marquer',
  page_mark_escape: 'Échap',
  page_mark_shape_box: 'Encadré',
  page_mark_shape_circle: 'Cercle',
  page_mark_shape_arrow: 'Flèche',
  page_mark_shape_bracket: 'Crochet',
  page_mark_shape_underline: 'Soulignement',
  page_mark_shape_highlight: 'Surlignage',
  page_mark_shape_strike_through: 'Barré',
  page_mark_shape_crossed_off: 'Biffé',
  page_mark_shape_aria: 'Forme de la marque : {shape}',
  page_mark_note_placeholder: 'Ajouter une note… (Entrée pour joindre)',
  page_mark_attach: 'Joindre la marque',
  page_mark_remove: 'Supprimer {label}',
  page_mark_region: 'Zone marquée',
  page_mark_default_message: 'Qu’est-ce que c’est ?',
  file_rejected:
    'Le type de fichier n’est pas pris en charge ou le fichier est trop volumineux.',
  dictate: 'Dicter',
  stop_dictation: 'Arrêter la dictée',
  dictation_mic_blocked: "Autorisez l'accès au micro pour dicter",
  dictation_unavailable: 'La dictée est indisponible pour le moment',
  questions_back: 'Retour',
  questions_next: 'Suivant',
  questions_send: 'Envoyer',
  questions_type_answer: 'Je préfère écrire',
  questions_answer_placeholder: 'Écrivez votre réponse…',
  close_conversation_title: 'Fermer la conversation',
  close_conversation_description:
    'Voulez-vous vraiment fermer cette conversation ?',
  close_conversation_cancel: 'Non',
  close_conversation_confirm: 'Oui',
  dialog_close: 'Fermer',
  zoom_in: 'Zoom avant',
  zoom_out: 'Zoom arrière',
  reset_zoom: 'Réinitialiser le zoom',
  support_chat_aria_label: 'Chat de support',
};
